module.exports = __webpack_public_path__ + "img/history.2a8036fc.svg";